import React            from "react";
import Button           from '@mui/material/Button';

import { articleEdit }  from '../../../apis/article';

export default function ActionBtn (props) {
	const { row } = props;

	const disableFlag = (d) => {
		if (d.status === 'published')
			return true;
		if (d.status === 'archived')
			return true;

		return false;
	}

	const doPublish = async (row) => {
		try {
			let data = { '_id' : row._id, 'status' : 'published' };
			const resp = await articleEdit (data);
			window.alert (`Blog "${resp.title}" has been updated. The page will roload.`);
			window.location.reload ();

		} catch (err) {
			console.error (err);
		}
	}

	const doRedirect = (row) => {
		try {
			window.open (`${window.location.origin}/blog/edit?title=${row.url}`, '_blank');
		} catch (err) {
			console.error (err);
		}
	}


	return (
		<>
		<Button
			variant="contained"
			size="small"
			disabled={disableFlag (row)}
			onClick={(e) => {doRedirect (row)}}>
				Edit
		</Button>
		&nbsp;
		<Button
			variant="contained"
			size="small"
			disabled={disableFlag (row)}
			onClick={(e) => {doPublish (row)}}>
				Publish
			</Button>
		</>
	);
}
